import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Select from '../../../../../../../components/global/Select';
import Label from '../../../../../../../components/global/Label';
import { getTeamLabel } from '../../../../../../../util/album-folder-tags';

const propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    uniform_enabled: PropTypes.bool.isRequired,
    uniform_numbered: PropTypes.bool.isRequired,
    levels: PropTypes.shape({
      records: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          teams: PropTypes.shape({
            records: PropTypes.arrayOf(
              PropTypes.shape({
                id: PropTypes.string.isRequired,
                name: PropTypes.string,
                coach_name: PropTypes.string,
              }),
            ),
          }),
        }),
      ),
    }),
  }).isRequired,
  value: PropTypes.shape({
    tagId: PropTypes.string,
    levelId: PropTypes.string,
    teamId: PropTypes.string,
    jerseyNumber: PropTypes.string,
  }),
  className: PropTypes.string,
  index: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
};

const TeamDetailsSelection = ({
  tag,
  value,
  handleChange,
  index,
  className,
}) => {
  const classes = classNames({
    'team-details-selection': true,
    [className]: !!className,
  });

  const fieldBase = `selectedTags.${tag.id}[${index}]`;
  const levels = tag.levels?.records ?? [];
  const selectedLevel = levels.find(({ id }) => id === value.levelId);
  const selectedLevelTeams = selectedLevel?.teams?.records ?? [];
  const removeJoinedCount = true;
  const jerseyNumbers = useMemo(() => {
    const numbers = [];
    for (let i = 0; i < 100; i += 1) {
      if (i < 10) {
        numbers.push(`0${i}`);
      } else {
        numbers.push(`${i}`);
      }
    }
    return numbers;
  }, []);

  return (
    <div className={classes}>
      {levels.length > 0 && <Label id="level-select">Level</Label>}

      {levels.length > 0 && (
        <Select
          id="level-select"
          name={`${fieldBase}.levelId`}
          onChange={event => {
            handleChange({
              target: {
                name: `${fieldBase}.levelId`,
                value: event.target.value,
              },
            });

            // Reset the team if we're changing levels
            handleChange({
              target: {
                name: `${fieldBase}.teamId`,
                value: '',
              },
            });
          }}
          className="mb-1"
          value={value.levelId}
        >
          <option value="">Select your level&hellip;</option>
          {levels.map(level => {
            return (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            );
          })}
        </Select>
      )}

      {selectedLevelTeams.length > 0 && (
        <Select
          id="team-select"
          name={`${fieldBase}.teamId`}
          onChange={handleChange}
          className="mb-0"
          value={value.teamId}
        >
          <option value="">Team or Coach Name&hellip;</option>

          {selectedLevelTeams.map(team => {
            return (
              <option key={team.id} value={team.id}>
                {getTeamLabel(team, removeJoinedCount)}
              </option>
            );
          })}
        </Select>
      )}

      {tag.uniform_enabled && tag.uniform_numbered && (
        <div className="tag-details-selection-jersey-number">
          <Select
            id="jersey-number"
            name={`${fieldBase}.jerseyNumber`}
            label="Jersey number"
            value={value.jerseyNumber}
            onChange={handleChange}
            placeholder="Enter your jersey number…"
            className="mb-0"
          >
            <option value="">None</option>
            {jerseyNumbers.map(number => (
              <option key={number} value={number}>
                {number}
              </option>
            ))}
          </Select>
        </div>
      )}
    </div>
  );
};

TeamDetailsSelection.propTypes = propTypes;

export default TeamDetailsSelection;
